export function isIOS() {
  return (
    /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase())
  );
}

export function isInStandaloneMode() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}
